import MultiSelectFilter from './MutilSelectFilter';

export default MultiSelectFilter;
